import { FileText, User, Calendar, Settings } from "lucide-react";

interface SystemInformationProps {
  nomorSuratIzin: string;
  submittedBy: string;
  status: string;
  submissionDateTime?: string;
}

export default function SystemInformation({
  nomorSuratIzin,
  submittedBy,
  status,
  submissionDateTime,
}: SystemInformationProps) {
  const displayDateTime =
    submissionDateTime ||
    new Date().toLocaleString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
        <div>
          <label className="block text-xs font-bold text-slate-400 dark:text-slate-500 mb-2 uppercase tracking-wide">
            Nomor Surat Izin
          </label>
          <div className="relative">
            <FileText className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
            <input
              type="text"
              value={nomorSuratIzin}
              disabled
              className="w-full pl-10 pr-4 py-2.5 text-xs bg-slate-50 text-slate-500 border border-slate-200 rounded-xl dark:bg-gray-700/50 dark:text-gray-400 dark:border-gray-600 cursor-not-allowed font-medium"
            />
          </div>
        </div>

        <div>
          <label className="block text-[11px] font-bold text-slate-400 dark:text-slate-500 mb-1.5 uppercase tracking-wide">
            Diajukan Oleh
          </label>
          <div className="relative">
            <User className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
            <input
              type="text"
              value={submittedBy}
              disabled
              className="w-full pl-10 pr-4 py-2.5 text-xs bg-slate-50 text-slate-500 border border-slate-200 rounded-xl dark:bg-gray-700/50 dark:text-gray-400 dark:border-gray-600 cursor-not-allowed font-medium"
            />
          </div>
        </div>

        <div>
          <label className="block text-[11px] font-bold text-slate-400 dark:text-slate-500 mb-1.5 uppercase tracking-wide">
            Tanggal Pengajuan
          </label>
          <div className="relative">
            <Calendar className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
            <input
              type="text"
              value={displayDateTime}
              disabled
              className="w-full pl-10 pr-4 py-2.5 text-xs bg-slate-50 text-slate-500 border border-slate-200 rounded-xl dark:bg-gray-700/50 dark:text-gray-400 dark:border-gray-600 cursor-not-allowed font-medium"
            />
          </div>
        </div>

        <div>
          <label className="block text-[11px] font-bold text-slate-400 dark:text-slate-500 mb-1.5 uppercase tracking-wide">
            Status Permohonan
          </label>
          <div className="relative">
            <Settings className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
            <input
              type="text"
              value={status}
              disabled
              className="w-full pl-10 pr-4 py-2.5 text-xs bg-slate-50 text-slate-500 border border-slate-200 rounded-xl dark:bg-gray-700/50 dark:text-gray-400 dark:border-gray-600 cursor-not-allowed font-medium"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
